import { useMemo } from "react";
import { jwtDecode } from "jwt-decode";
import { checkUsername } from "../UserDashboard/filterUtils";
import { isRaportCzasowUser } from "../../utils/raportCzasowAccess";
import { isRaportMwUser } from "../../utils/raportMagazynWarszawaAccess";

// Dostęp do "Zarządzanie listą" w module Magazyn Warszawa (admin albo wskazani użytkownicy).
const MAGAZYN_LISTS_USERNAMES = [
  "dwieteska",
  "eleszek",
  "aforys",
  "ljuszczynski",
  "mkornata",
  "lfijolek",
  "pgalinski",
  "jcizewska",
];

// Dane zalogowanego użytkownika wyliczone z tokena (raz na montowanie strony).
export const useSession = () =>
  useMemo(() => {
    let username = "";
    let role = "";
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        username = decoded.username || "";
        role = decoded.role || "";
      } catch (e) {
        // nieprawidłowy token - strony i tak są chronione przez routing
      }
    }
    return {
      username,
      role,
      isAdmin: role === "admin",
      isLists: checkUsername(),
      isMagazynLists: role === "admin" || MAGAZYN_LISTS_USERNAMES.includes(username),
      isRaportCzasow: isRaportCzasowUser(username),
      isRaportMw: isRaportMwUser(username),
    };
  }, []);

export default useSession;
